export function isWizardEmail(email: string | null | undefined) {
  const normalizedEmail = email?.trim().toLowerCase();

  return Boolean(
    normalizedEmail?.endsWith('@joinwaterlily.com') || normalizedEmail?.endsWith('@aterlily.com'),
  );
}

export function isWizard(
  advisor: Pick<Advisor, 'advisorEmail' | 'featureFlags'> | null | undefined,
) {
  return Boolean(isWizardEmail(advisor?.advisorEmail) || advisor?.featureFlags?.wizardMode);
}
